module.exports = __webpack_public_path__ + "img/symbol_7.470c21ef.png";